<div class="plan-details-container">
  <div class="details-section">
    <div class="details-row">
      <div class="detail-item">
        <div class="label">Plan</div>
        <div class="value">Way 360</div>
      </div>
      <div class="detail-item">
        <div class="label">Plan Cost</div>
        <div class="value">$71.98/mo</div>
      </div>
      <div class="detail-item">
        <div class="label">Users</div>
        <div class="value">10</div>
      </div>
      <div class="detail-item">
        <div class="label">Billing Cycle</div>
        <span class="value">Monthly</span>
      </div>
    </div>
  </div>
  <div class="details-section">
    <div class="details-row">
      <div class="detail-item">
        <div class="label">Email Usage/Limit</div>
        <div class="value">4.5k<span class="text-muted">/5k</span></div>
      </div>
      <div class="detail-item">
        <div class="label">SMS Usage/Limit</div>
        <div class="value">9k<span class="text-muted">/10k</span></div>
      </div>
      <div class="detail-item">
        <div class="label">Transaction Usage/Limit</div>
        <div class="value">50k<span class="text-muted">/75k</span></div>
      </div>
      <div class="detail-item">
        <div class="label">Way+ Usage/Limit</div>
        <div class="value">25k<span class="text-muted">/50k</span></div>
      </div>
    </div>
  </div>
  <div class="payment-section">
    <div class="payment-item last-payment">
      <div class="payment-info">
        <div class="payment-label">Last Payment</div>
        <div class="payment-date">January 7, 2025</div>
      </div>
      <div class="payment-amount">$71.98</div>
    </div>
    <div class="payment-item text-right-mobile">
      <div class="payment-info ">
        <div class="payment-label">Next Payment</div>
        <div class="payment-date">February 7, 2025</div>
      </div>
      <div class="payment-amount">$71.98</div>
    </div>
  </div>
</div>
